import type { RoseRocketInvoice } from '../types/entities';
import { isCurrency, isIsoDate, isIsoTimestamp, required } from './common';

export function validateInvoice(invoice: RoseRocketInvoice): string[] {
  const errors: string[] = [];
  if (!required(invoice.id)) errors.push('Missing invoice id');
  if (!required(invoice.invoice_number)) errors.push('Missing invoice number');
  if (!required(invoice.customer_name)) errors.push('Missing customer name');
  if (!required(invoice.status)) errors.push('Missing invoice status');
  if (invoice.amount === undefined || Number.isNaN(Number(invoice.amount))) errors.push('Invalid amount');
  if (!isCurrency(invoice.currency)) errors.push('Invalid currency code');
  if (!isIsoDate(invoice.issued_date)) errors.push('Invalid issued date');
  if (!isIsoDate(invoice.due_date)) errors.push('Invalid due date');
  if (!isIsoTimestamp(invoice.updated_at)) errors.push('Invalid updated_at timestamp');
  return errors;
}
